export type GridSortValue = string | number | null;

export interface GridSort {
  key: string;
  direction: "asc" | "desc";
}

/** Nulls sort last; numbers numerically; strings with natural numeric ordering, case-insensitive. */
export function compareSortValues(a: GridSortValue, b: GridSortValue): number {
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: "base" });
}
